import { PRODUCT_EFFECT } from '@constants/buzzkuri/program-detail'
import React from 'react'
import { ProductEffectItem } from './Item'

export const ProductEffect = (): JSX.Element => {
  return (
    <div className="w-[87.2vw] lg:w-[24.6vw] h-[37.9vw] lg:h-[11.1vw] rounded-[3px] border border-[#F0F0F0]">
      <div className="flex flex-col p-[6.1vw] lg:pt-[2vw] lg:pr-[2.5vw] lg:pb-[1.6vw] lg:pl-[2.6vw]">
        {PRODUCT_EFFECT.map((item, i) => (
          <div
            key={i}
            className="mt-[2vw] lg:mt-[.3vw] lg:first:mt-0 border-b last:border-b-0 border-[#999999]"
          >
            <ProductEffectItem {...item} />
          </div>
        ))}
      </div>
    </div>
  )
}
